export const AUTH_TOKEN = "authToken";

export const LATITUDE = "lat";

export const LONGITUDE = "long";

export const POS_INFO = "posInfo";

export const PREFERRED_DELIVERY_AREA = "preferred-delivery-area";

export const SELECTED_ADDRESS_ID = "selectedAddressID";

export const STORE_INFO = "storeInfo";
